import { render, staticRenderFns } from "./volaille.vue?vue&type=template&id=6cfeb2f3&scoped=true"
import script from "./volaille.vue?vue&type=script&lang=js"
export * from "./volaille.vue?vue&type=script&lang=js"
import style0 from "./volaille.vue?vue&type=style&index=0&id=6cfeb2f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfeb2f3",
  null
  
)

export default component.exports